/** Storage KEYS */
export const Token = 'token' // Token Key
export const Username = 'username' // Username Key
export const UserId = 'userId' // UserId Key
export const Email = 'email' // Email Key
export const UserRole = 'role' // SCS Super User Key
export const UserInfo = 'userinfo' // SCS Super User Key

export const LocalStoreKeys = [Token, Username, UserId, Email, UserRole, UserInfo] // Array of Keys for Local Storage
export const LocalStoreExemptKeys = [Token, Email] // Array for Exempted for Encryption or other means of processing
